export enum PassengerChangeFormKeysEnum {
  wasPassengerChanged = 'wasPassengerChanged',
  firstName = 'firstName',
  lastName = 'lastName',
  gender = 'genderSelector',
  dateOfBirth = 'dateOfBirth',
  identifier = 'identifier',
  departureAirportName = 'departureAirportName',
  arrivalCode = 'arrivalCode',
  departureCode = 'departureCode',
  departure = 'departure',
  arrival = 'arrival',
  arrivalAirportName = 'arrivalAirportName'
}

export const PassengerChangeFormArrayName = 'passengers';
export type PassengerChangeFormKeysEnumType = keyof typeof PassengerChangeFormKeysEnum;
